<template>
  <header>
    <section data-nosnippet>
      <div v-if="!contactLoaded" class="pt-2">
        <b-spinner label="Loading..." style="color:#002b36;"></b-spinner>
      </div>
      <b-container v-else fluid id="kub-header-navigation">
        <b-row class="kub-max-width">
          <b-col>
            <div class="d-flex pt-2 pb-2 mt-1 mb-1 align-items-end" @click="reloadPage()" style="cursor:pointer;">
              <b-img :src="header.kubLogoLight" class="img-fluid" id="kub-logo-light" alt="Kubulus Logo hell" v-b-visible="handleVisibility"></b-img>
            </div>
          </b-col>
          <b-col cols="auto" class="d-flex align-items-center justify-content-end">
            <ul class="nav">
              <li class="nav-item kub-icon-gap">
                <div class="d-flex align-items-center">
                  <a class="kub-contact d-flex align-items-center" :href="contact.homepage.content" target="_blank" rel="noopener noreferrer">
                    <b-icon :icon="contact.homepage.icon" class="mr-2" :font-scale="md ? 1 : 1.5"></b-icon>
                    <span>{{ contact.homepage.text }}</span>
                  </a>
                </div>
              </li>
              <li class="nav-item kub-icon-gap">
                <div class="d-flex align-items-center">
                  <a class="kub-contact d-flex align-items-center" :href="'mailto:' + contact.mail.content">
                    <b-icon :icon="contact.mail.icon" class="mr-2" :font-scale="md ? 1 : 1.5"></b-icon>
                    <span>{{ contact.mail.content }}</span>
                  </a>
                </div>
              </li>
              <li class="nav-item">
                <div class="d-flex align-items-center">
                  <a class="kub-contact d-flex align-items-center" :href="'tel:' + contact.phoneTo.content">
                    <b-icon :icon="contact.phone.icon" class="mr-2" :font-scale="md ? 1 : 1.5"></b-icon>
                    <span class="mr-0">{{ contact.phone.content }}</span>
                  </a>
                </div>
              </li>
            </ul>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </header>
</template>

<script>
import Data from '../../data/header/header'
import DataContact from '../../data/general/contact'

import DataService from '../../services/DataService'

import { mapActions, mapGetters } from 'vuex'

import { createHelpers } from 'vuex-map-fields'

const { mapFields } = createHelpers({
  getterType: 'getLogoField',
  mutationType: 'updateLogoField'
})

export default {
  data () {
    return {
      header: Data.header,
      contact: DataContact.contact,
      contactLoaded: false
    }
  },
  methods: {
    reloadPage () {
      window.location.reload()
    },
    ...mapActions([
      'contactLoadingError'
    ]),
    handleVisibility (isVisible) {
      this.logoVisible = isVisible
    }
  },
  computed: {
    ...mapGetters([
      'xs',
      'sm',
      'md',
      'lg',
      'xl'
    ]),
    ...mapFields([
      'logoVisible'
    ])
  },
  async created () {
    try {
      await DataService.getContact()
      this.contactLoaded = true
    } catch (err) {
      this.contactLoadingError()
      console.log(err)
    }
  }
}
</script>

<style scoped>
#kub-logo-light {
  height: 2rem;
  width: auto;
}

#kub-header-navigation {
  position: relative;
  color: #fff;
  background-color: #002b36;
  z-index: 400;
}

span {
  margin-right: 1rem;
}

h1 {
  font-size: 1.75rem;
}

h1 > img {
  margin-bottom: 5px;
  margin-top: 5px;
}

.kub-contact {
  color:#fff;
}

.kub-contact:hover {
  color:#fff;
  background-color: #002b36;
}

.kub-icon-gap {
  margin-right: 0.5rem !important;
}

@media (max-width: 1200px) {
  #kub-logo-light {
    height: 2rem;
    width: auto;
  }
}

@media (max-width: 992px) {
  h1 > span {
    display: none;
  }

  #kub-logo-light {
    height: 1.75rem;
    width: auto;
  }
}

@media (max-width: 767px) {
  .kub-icon-gap {
    margin-right: 1rem !important;
  }

  a > span {
    display: none;
  }
}
</style>
